import { SET_CITATION_DETAIL } from "./action";

const defaultState = {};
export default function citationDetailReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_CITATION_DETAIL:
      return action.payload;
    default:
      return state;
  }
}
